/**
 * 🟥 CUADRO NEGRO Panel de Suscripción Único (feb-2026).
 *
 * Función global para abrir el "Panel de Suscripción" real — el widget
 * que aparece sobre el Área de Trabajo con los botones $9 y $86
 * ($9/mes y $86/año). Reemplaza CUALQUIER intento previo de navegar a
 * páginas informativas como /home, /planes, /pricing, /beneficios:
 * TODOS los CTAs Premium de la app deben llamar a esta función.
 *
 * Mecánica:
 *   1. Si ya estamos en el Dashboard (/home) → disparamos el evento
 *      global `damyxia:open-subscription-panel` que el Dashboard
 *      escucha para setear `showSubscriptionWidget(true)`.
 *   2. Si estamos en otra ruta → guardamos un flag en sessionStorage
 *      y navegamos a /home. El Dashboard, al montar, detecta el flag
 *      y abre el widget automáticamente.
 *
 * NO usa Stripe Billing Portal (eso es solo para usuarios Premium
 * activos). El upgrade desde Free siempre pasa por este widget.
 */

export const SUBSCRIPTION_PANEL_OPEN_FLAG = 'damyxia.openSubscriptionPanelOnHome';
export const SUBSCRIPTION_PANEL_EVENT = 'damyxia:open-subscription-panel';

/**
 * Abre el Panel de Suscripción real. Llamala desde CUALQUIER CTA
 * Premium (modal del Genio, Mi Suscripción, banners, etc.).
 *
 * 🟪 P25.30 · Migración de hard reload → navegación SPA.
 * `window.location.assign('/')` recarga la página completa y crea una
 * condición de carrera con el mount del `SubscriptionUpgradeOverlayMount`
 * (el flag se limpia antes de que el `useEffect` corra). Ahora usamos
 * `history.pushState` + `popstate` para que React Router navegue sin
 * recarga; luego disparamos el evento tras el próximo tick para asegurar
 * que el componente esté montado.
 */
export function openSubscriptionPanel(navigate) {
  if (typeof window === 'undefined') return;

  const path = window.location.pathname || '/';
  const isOnDashboard = path === '/' || path === '/index.html';

  const fire = () => {
    try {
      window.dispatchEvent(new CustomEvent(SUBSCRIPTION_PANEL_EVENT));
    } catch { /* ignore */ }
  };

  if (isOnDashboard) {
    fire();
    return;
  }

  // Preferido: navegación por React Router (si el consumidor pasa
  // `navigate` desde `useNavigate()`). Es la manera correcta y no rompe
  // el estado interno del Router.
  try { sessionStorage.setItem(SUBSCRIPTION_PANEL_OPEN_FLAG, '1'); } catch { /* ignore */ }

  if (typeof navigate === 'function') {
    navigate('/');
    setTimeout(fire, 200);
    return;
  }

  // Fallback: hard reload sólo cuando NO tenemos el hook a mano. El
  // `SubscriptionUpgradeOverlayMount` lee el flag de sessionStorage al
  // montar y abre el overlay automáticamente.
  try {
    window.location.href = '/';
  } catch {
    window.location.assign('/');
  }
}

export default openSubscriptionPanel;
